<!--  -->
<template>
    <div class="wrapper box  box_v">
        <page-head title="预约设置" :btn-list="btnList" @handleBtn="handleBtn" :show-back="true">
        </page-head>
        <Card class="card-wrapper1">
            <div class="box set-content" v-for="(item,index) in list" :key="item.id">
                <div class="box set-item">
                    <div class="box_f1 set-title">第{{item.num}}轮预约</div>
                    <div class="box_f1 set-shuoming">{{item.beginTime}} 至 {{item.endTime}}</div>
                    <div class="box_f1 set-edit" @click="edit(index)">
                        <i class="iconfont icon-bianji1"></i>
                        编辑
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pageHead from '../../../components/head'

export default {
    //import引入的组件需要注入到对象中才能使用
    name: 'yuyueSetting',
    components: {pageHead},
    data() {
    //这里存放数据
        return {
            btnList: [{
                name: '新增',
                type: 'add',
                loading: false,
            }],
            list:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleBtn(type){
            if (type == 'add') this.$router.push({name:'addYuyue',query:{num:this.$util.number2Chinese(this.list.length+1)}})
        },
        edit(idx){
            this.$router.push({name:'addYuyue',query:{id:this.list[idx].id,num:this.list[idx].num}})
        },
        getList(){
            this.$post(this.urlobj.getYuyueSettingList,{}).then(res=>{
                this.list = res.rows.map(item=>{
                    return{
                        id:item.id,
                        beginTime:item.beginTime.substring(0,item.beginTime.length-5),
                        endTime:item.endTime.substring(0,item.beginTime.length-5),
                        num:this.$util.number2Chinese(item.roundNO)
                    }
                })
            }).catch(e=>{
                
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getList()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
  .wrapper{
    height: 100%
  }
  .card-wrapper1 {
    height: 100%;
    margin: 0 20px 20px 20px;
  }
  .set-content {
    width: 100%;
    padding-bottom: 30px;
    padding-top: 30px;
    border-bottom: 1px solid #eee;
  }
  .set-item {
    width: 70%;
  }
  .set-title {
    font-size: 18px;
  }
  .set-shuoming {
    margin-left: -20%;
    font-size: 16px;
  }
  .set-edit {
    font-size: 16px;
    color: #677a9e;
  }
  /deep/ .ivu-card-body {
    padding-top: 0;
    padding-right: 0;
  }
</style>